<template>
  <div :class="_.main">
    <div :class="_.bd">
      <img
        :src="
          error ? require('./images/失败.png') : require('./images/成功.png')
        "
        :class="_.icon"
      />
      <div :class="_.title">{{ title }}</div>
      <div v-if="message" :class="_.desc">{{ message }}</div>
      <div :class="_.actions">
        <x-button
          v-track="{
            name: '返回首页',
            id: '72669153-530c-4b2f-ab45-778f0b614935',
          }"
          gray
          @click="handleCancelClick"
        >
          返回首页
        </x-button>
        <x-button
          v-track="confirmTrack"
          :class="_.confirm"
          @click="handleConfirmClick"
        >
          {{ confirmText }}
        </x-button>
      </div>
    </div>

    <x-goods-recommend
      v-if="$globalModel.state.channelIsShowDcbResource"
      :resource-position-id="guessResourcePositionId"
    />
  </div>
</template>

<script>
  import Vue from 'vue'
  import { dcb } from '@dcb/jssdk'
  import { globalModel } from '@/model'
  import { redirectTo } from '@/router'

  export default Vue.extend({
    props: {
      error: {
        type: Boolean,
        default: false,
      },
      title: {
        type: String,
        required: true,
      },
      message: {
        type: String,
        default: '',
      },
      confirmText: {
        type: String,
        required: true,
      },
      confirmTrack: {
        type: Object,
        default: () => ({}),
      },
      guessResourcePositionId: {
        type: String,
        required: true,
      },
    },

    methods: {
      // 点击取消
      handleCancelClick() {
        if (globalModel.state.channelJumpRoute) {
          dcb.navigateTo({
            url: globalModel.state.channelJumpRoute,
          })
        } else {
          redirectTo('HomeIndex')
        }
        this.$emit('cancel')
      },

      // 点击确认
      handleConfirmClick() {
        this.$emit('confirm')
      },
    },
  })
</script>

<style lang="scss" module>
  .main {
    .bd {
      background-color: white;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 32px 0;

      .icon {
        width: 55px;
        height: 55px;
      }

      .title {
        margin-top: 12px;
        font-size: 16px;
        font-weight: bold;
        color: #222222;
      }

      .desc {
        margin-top: 12px;
        font-size: 14px;
        color: #888888;
      }

      .actions {
        margin-top: 24px;
        display: flex;
        align-items: center;

        .confirm {
          margin-left: 24px;
        }
      }
    }
  }
</style>
